import { useState, useEffect } from "react";
import Speech from "speak-tts";

const useSpeech = () => {
  const [word, sayWord] = useState();
  const [speech, setSpeech] = useState();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    setSpeech(new Speech());
  }, []);

  useEffect(() => {
    if (speech !== undefined) {
      speech
        .init({
          volume: 1,
          lang: "en-GB",
          rate: 0.8,
          pitch: 1
        })
        .catch(e => {
          console.error("An error occured while initializing : ", e);
        });
    }
  }, [speech]);

  useEffect(() => {
    if (speech !== undefined) {
      speech
        .speak({
          text: word,
          queue: false
        })
        .then(data => {})
        .catch(e => {});
      setStatus("done");
    }
    console.log("word changed to : " + word);
  }, [word]);

  return {
    sayWord
  };
};

export default useSpeech;
